import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";
import type { FeatureName } from "@lib/featureFlipper";

import { hasLandingPagesPermissions } from "@services/useLandingPagesPermissions";

const LandingPageSettings = lazy(() =>
  import("@scenes/AppSettings/LandingPageSettings").then((module) => ({
    default: module.LandingPageSettings,
  }))
);

export const landingPageSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  Component: LandingPageSettings,
  componentFeatureFlippers: ["landing_pages"],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("landing-page-settings-nro-heading", "Landing Page Settings"),
  pageNameForTracking: () => "Landing Page Settings",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    const isLandingPagesEnabled = featureOn("landing_pages");

    // Show the settings page if the flipper for any LP setting is enabled.
    // Fine-grained control of each flipper should be in the LandingPageSettings scene to allow fine-grained enabling.
    const flippers: FeatureName[] = ["landing_pages_custom_domain"];
    const someLandingPageSettingsEnabled = flippers.some((ff) => featureOn(ff));

    const { canReadLandingPages } = hasLandingPagesPermissions({
      hasPermission,
    });

    return isLandingPagesEnabled && canReadLandingPages && someLandingPageSettingsEnabled;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
